import './_alert.scss';
import './_alert.dark-mode.scss';
import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Tooltip from '../Tooltip';

const AlertComponent = ({ text, type, dismiss, classNames, onDismiss, tooltipOnClose, children }) => {
  const [show, setShow] = useState(true);

  const handleDismiss = () => {
    setShow(!show);
    onDismiss?.();
  };

  if (show) {
    return (
      <Alert className={`alert__custom ${classNames}`} bsStyle={type}>
        {dismiss && tooltipOnClose && (
          <Tooltip id="alert-tooltip" placement="left" text="Close the alert for 24 hours." tooltipClass="tooltip__left">
            <button onClick={handleDismiss} type="button" className="close" style={{ position: 'relative' }}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close alert</span>
            </button>
          </Tooltip>
        )}
        {dismiss && !tooltipOnClose && (
          <button onClick={handleDismiss} type="button" className="close" style={{ position: 'relative' }}>
            <span aria-hidden="true">×</span>
            <span className="sr-only">Close alert</span>
          </button>
        )}
        <span dangerouslySetInnerHTML={{ __html: text }} />
        {children}
      </Alert>
    );
  }
  return null;
};

AlertComponent.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  dismiss: PropTypes.bool,
  tooltipOnClose: PropTypes.bool,
  classNames: PropTypes.string,
  onDismiss: PropTypes.func,
  children: PropTypes.object,
};

AlertComponent.defaultProps = {
  type: 'danger',
};

export default AlertComponent;
